import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { CrudService } from '../../../crud/crud.service';

import { CurrencyPipe } from "@angular/common";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';

@Component({
  selector: 'app-formulario-caja',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit{
  dato: FormGroup;
  json;
  tab = 1;
  cargando = false;
  mensaje = "";
  exito = "default";
  tiene_id = false;
  usuario;
  permisos;
  cerrar_caja = false;
  tamano = document.body.clientHeight;
  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  constructor(private crudService: CrudService, private route: ActivatedRoute, private fb: FormBuilder) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [''],
      cajas_id: ['', [Validators.required]],
      fecha_apertura: [''],
      fecha_cierre: [''],
      cerrado_por: [''],
      provision_inicial: ['', [Validators.required]],
      importe_cierre: [''],
      venta_total: [''],
      status: [1],
      pagos: this.fb.array([]),
      flujos_efectivos: this.fb.array([]),
      pagos_entradas: this.fb.array([]),
      pagos_salidas: this.fb.array([]),
      flujos_agrupados: this.fb.array([]),
      tipos_movimientos: this.fb.array([]),
      cajas: this.fb.group({ id: [''], nombre: [''] }),
      abrio: this.fb.group({ id: [''], nombre: [''] }),
      cerro: this.fb.group({ id: [''], nombre: [''] })
    });

    this.permisos = JSON.parse(localStorage.getItem("permisos"));
    this.usuario = JSON.parse(localStorage.getItem('usuario'));


    this.route.params.subscribe(params => {
      if (!params['id']) {
        let d = new Date();
        const ctrl = <FormGroup>this.dato.controls.abrio;
        ctrl.controls.nombre.patchValue(this.usuario.nombre);
        this.dato.controls.fecha_apertura.patchValue(d.getFullYear() + "-" + ('00' + d.getMonth() + 1).slice(-2) + "-" + d.getDate() + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds());
      }
      else {
        this.tab = 2;
        this.tiene_id = true;
      }
    });
    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById('catalogos').click();
  }

  enviar() {
    if (this.tiene_id && this.cerrar_caja) {
      this.dato.controls.status.patchValue(0);
      this.ir_cerrar_caja();
    }
    else {
      this.ir_abrir_caja();
    }
  }
  ir_abrir_caja() {
    let url = "caja-operacion";

    this.cargando = true;
    let json = this.dato.getRawValue();
    this.mensaje = "";

    this.crudService.crear(json, url).subscribe(
      resultado => {
        this.cargando = false;
        this.exito = "success";
        this.mensaje = "La caja se abrio correctamente";
        localStorage.setItem('caja', json.cajas_id);

        this.cerrar_caja = false;
      },
      error => {
        this.cargando = false;
        this.cerrar_caja = false;
        try {
          let e = error.json();
          if (error.status == 401) {
            this.mensaje = "No tiene permiso para hacer esta operación.";
            this.exito = "warning";
          } else {
            let cuerpo = error._body ? JSON.parse(error._body) : '';
            this.mensaje = cuerpo.messages ? cuerpo.messages : 'No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir :(';
            this.exito = "info";
          }

        } catch (e) {
          this.mensaje = "Algo salio mal :(.";
          this.exito = "danger";
        }
      }
    );
  }

  ir_cerrar_caja() {
    let url = "caja-operacion";
    this.cargando = true;
    this.dato.controls.status.patchValue(0);
    let json = this.dato.getRawValue();
    this.mensaje = "";
    this.crudService.editar(this.dato.get('id').value, json, url).subscribe(
      resultado => {
        this.cargando = false;
        this.exito = "success";
        this.mensaje = "La caja se cerro correctamente";

        localStorage.removeItem('caja');
        this.cerrar_caja = false;

        const uc = this.dato.controls.cerro;
        uc.patchValue(this.fb.group({ id: [this.usuario.id], nombre: [this.usuario.nombre] }));

        let d = new Date();
        this.dato.controls.fecha_cierre.patchValue(d.getFullYear() + "-" + ('00' + d.getMonth() + 1).slice(-2) + "-" + d.getDate() + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds());
        setTimeout(() => {
          document.getElementById('impirmir_cierre').click();
        }, 100);
      },
      error => {
        this.cargando = false;
        this.cerrar_caja = false;
        try {
          let e = error.json();
          if (error.status == 401) {
            this.mensaje = "No tiene permiso para hacer esta operación.";
            this.exito = "warning";
          }

        } catch (e) {
          this.mensaje = "Algo salio mal :(.";
          this.exito = "danger";
        }
      }
    );
  }

  cargarDato(a){
    this.json = a.getRawValue();
  }

  imprimir() {

    let doc = new jsPDF("p", "mm", "letter");

    let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
    if (logo != '' && logo != undefined && logo != null)
      doc.addImage(logo, "PNG", 7, 5, 25, 20, "left", "FAST");

    let linea = 22;
    //Header
    doc.setFontSize(15);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.nombre, 108, 12, {align:"center"});

    doc.setFontSize(14);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.subnombre,108, 18,  {align:"center"});
    linea += 4;
    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.sucursal.direccion.split(",")[0],108, linea,  {align:"center"});
    linea += 4;
    doc.text(this.configuracion.sucursal.direccion.split(",")[1],108, linea,  {align:"center"});
    linea += 4;
    doc.text("RFC: " + this.configuracion.sucursal.facturacion.rfc,108, linea,  {align:"center"});
    linea += 6;

    doc.setFont("helvetica", "", "bold");
    doc.setFontSize(6);
    doc.text('------------------------------------------------------------------------------------------------------------------------------------------------------',108, linea,  {align:'center'});
    linea += 6;

    doc.setFontSize(12);
    doc.text('Campus: ' + this.configuracion.sucursal.nombre,108, linea,  {align:'center'});
    doc.setFontSize(10);
    linea += 4;
    doc.setFont("helvetica", "", "bold");
    doc.text('Telefono',108, linea,  {align:'center'});
    linea += 4;
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.sucursal.telefono,108, linea, {align: "center"});
    linea += 4;
    doc.setFont("helvetica", "", "bold");
    doc.text('Correo',108, linea,  {align:'center'});
    linea += 4;
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.sucursal.correo, 108, linea, {align:"center"});
    linea += 6;

    doc.setFontSize(6);
    doc.text('------------------------------------------------------------------------------------------------------------------------------------------------------',108, linea,  {align:'center'});
    linea += 6;

    doc.setFontSize(12);
    doc.text('CORTE DE CAJA',108, linea,  {align:'center'});
    linea += 6;

    let columns = [
      { title: "Fecha de apertura:", dataKey: "col1" },
      { title: this.dato.get('fecha_apertura').value, dataKey: "col2" },
      { title: "Fecha de cierre:", dataKey: "col3" },
      { title: this.dato.get('fecha_cierre').value, dataKey: "col4" }
    ];

    let rows = [
      { col1: "Caja:", col2: this.dato.get('cajas').value.nombre, col3: "Importe de cierre:", col4: this.convertirMoneda(((this.dato.get('venta_total').value * 1) + (this.dato.get('provision_inicial').value * 1))) },
      { col1: "Abierto por:", col2: this.dato.get('abrio').value.nombre, col3: "Cerrado por:", col4: this.dato.get('cerro').value.nombre }
    ];

    (doc as any).autoTable({
            columns:columns, 
            body: rows,
      didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: linea,
      styles: {
        fontSize: 8, font: "helvetica",
        halign: "center",
        fillColor: "#FFFFFF",
        textColor: "#000000",
        lineColor: "#000000",
        lineWidth: 0.3
      },
      headStyles: {
        lineColor: "#000000",
        lineWidth: 0.3
      },
    });
    linea += 28;

    if (this.json.pagos_entradas != undefined){
      if (this.json.pagos_entradas.length > 0){
        doc.setFontSize(9);
        doc.text('ENTRADAS',108, linea,  {align:'center'});
        linea += 3;

        let columns1 = [
          { title: "Importe:", dataKey: "col1" },
          { title: "Tipo:", dataKey: "col2" },
        ];
        let rows1 = [];
        this.json.pagos_entradas.forEach(item => {
          rows1.push({ col1: this.convertirMoneda(item.total), col2: item.tipo});
        });

        (doc as any).autoTable(columns1, rows1, {
          didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
            cell.styles.fillColor = "#ffffff";
          },
          startY: linea,
          styles: {
            fontSize: 8, font: "helvetica",
            halign: "center",
            fillColor: "#FFFFFF",
            textColor: "#000000",
            lineColor: "#000000",
            lineWidth: 0.3
          },
          headStyles: {
            lineColor: "#000000",
            lineWidth: 0.3
          },
        });
        linea += 8 * this.json.pagos_entradas.length + 10;
      }
    }

    if (this.json.pagos_salidas != undefined) {
      if (this.json.pagos_salidas.length > 0) {
        doc.setFontSize(9);
        doc.text('SALIDAS', 108, linea, {align:'center'});
        linea += 3;

        let columns1 = [
          { title: "Importe:", dataKey: "col1" },
          { title: "Tipo:", dataKey: "col2" },
        ];
        let rows1 = [];
        this.json.pagos_salidas.forEach(item => {
          rows1.push({ col1: this.convertirMoneda(item.total), col2: item.tipo });
        });

        (doc as any).autoTable(columns1, rows1, {
          didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
            cell.styles.fillColor = "#ffffff";
          },
          startY: linea,
          styles: {
            fontSize: 8, font: "helvetica",
            halign: "center",
            fillColor: "#FFFFFF",
            textColor: "#000000",
            lineColor: "#000000",
            lineWidth: 0.3
          },
          headStyles: {
            lineColor: "#000000",
            lineWidth: 0.3
          },
        });
        linea += 8 * this.json.pagos_salidas.length + 10;
      }
    }

    let columns2 = [
      { title: "Total Movimientos:", dataKey: "col1" },
      { title: this.convertirMoneda(this.dato.get('importe_cierre').value), dataKey: "col2" }
    ];

    let rows2 = [
      { col1: "F.E. Entrada:", col2: this.convertirMoneda((this.json.flujos_agrupados.length > 1 ? this.json.flujos_agrupados[1].total : 0)) },
      { col1: "F.E. Salida:", col2: this.convertirMoneda((this.json.flujos_agrupados.length > 0 ? this.json.flujos_agrupados[0].total : 0)) },
      { col1: "Provisión inicial:", col2: this.convertirMoneda(this.dato.get('provision_inicial').value) },
      { col1: "Total en caja:", col2: this.convertirMoneda(((this.dato.get('venta_total').value * 1) + (this.dato.get('provision_inicial').value * 1))) }
    ];

    (doc as any).autoTable(columns2, rows2, {
      didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: linea,
      styles: {
        fontSize: 8, font: "helvetica",
        halign: "center",
        fillColor: "#FFFFFF",
        textColor: "#000000",
        lineColor: "#000000",
        lineWidth: 0.3
      },
      headStyles: {
        lineColor: "#000000",
        lineWidth: 0.3
      },
    });
    linea += 52;

    doc.setFontSize(8);
    doc.line(80, linea , 150, linea);
    linea += 5;
    doc.text('Firma de quien entrega',108, linea,  {align:'center'});

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'corete-de-caja.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }
  convertirMoneda(importe) {
    return (new CurrencyPipe('en')).transform(importe, this.configuracion.sucursal.moneda, true);
  }

  logo_sucursal;
  logo_empresa;

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
    }
  }
}
